/**
 * @generated SignedSource<<a9d67733f4cac97fe9bbd881e0f3d487>>
 * @relayHash 98492ce2c9426aecb14f780fa6706941
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1944a31e9ad7d2d4e669bae0d03ef82cc15ec5de657f9a83316ea5fbd994e571

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceOverviewGroupedButtonsQuery$variables = {
  spaceKey: string;
};
export type SpaceOverviewGroupedButtonsQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isFavourited: boolean;
    };
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type SpaceOverviewGroupedButtonsQuery = {
  response: SpaceOverviewGroupedButtonsQuery$data;
  variables: SpaceOverviewGroupedButtonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isFavourited"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceOverviewGroupedButtonsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceOverviewGroupedButtonsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "98492ce2c9426aecb14f780fa6706941",
    "id": "1944a31e9ad7d2d4e669bae0d03ef82cc15ec5de657f9a83316ea5fbd994e571",
    "metadata": {},
    "name": "SpaceOverviewGroupedButtonsQuery",
    "operationKind": "query",
    "text": "query SpaceOverviewGroupedButtonsQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isFavourited}}}"
  }
};
})();

(node as any).hash = "0f2092e0d3b6952df62bf4345206b7d9";

export default node;
